module.exports = __webpack_public_path__ + "files/3812df668bb0144f7ae51853b202315b.mp3";


//////////////////
// WEBPACK FOOTER
// ./images/bing.mp3
// module id = 1297
// module chunks = 60